import { forwardRef, useEffect, useImperativeHandle, useState, useRef, useContext } from "react";
import CardCSS from "../../../../../../library/Card/Card";
import { MyContextHoldem } from '../CasinoHoldem';

// import isValidPaiGowSplit from "../../CheckCardRanks";

const CasinoholdemCardsContainer = forwardRef((props, ref) => {
    const [playerFirstHand, setPlayerFirstHand] = useState([])
    // const [playerSecondHand, setPlayerSecondHand] = useState([])
    const [dealerFirstHand, setDealerFirstHand] = useState([])
    const [dealerSecondHand, setDealerSecondHand] = useState([])
    const [originalPlayerCards, setOriginalCards] = useState(null);
    const [isDealt, setIsDealt] = useState(false)
    const [allowClick, setAllowClick] = useState(false)
    const [dealerhand, setdealerHandmessage] = useState("")
    const [playerHand, setPlayerHandmessage] = useState("")

    const playerHandIntervalRef = useRef(null);
    const dealerHandIntervalRef = useRef(null);
    const {
        Handmessage, setHandmessage,
        finalblinkcards, setfinalblinkcards,
        cardblink, setCardblink, betBtn, setBetBtn,
        clearBtn, setClearBtn,
        bonuswinamount, setbonuswiamount,
        undoBtn, setUndoBtn, winAmount, setWinAmount, Raiseactive, setRaiseactivated,   infoText, setInfoText, } = useContext(MyContextHoldem);


    useImperativeHandle(ref, () => ({
        setAllCards,
        setPlayerAllCards,
        setDealerUnsetCards,
        setDealerUnsetCardshold,
        prevstatesetDealerUnsetCards,
        prevstatesetDealerUnsetCardshold,
        revealDealerCards,
        revealBoardcards,
        setAllowClick,
        clearallcards,
        setdealerHandmessage,
        setPlayerHandmessage
    }))

    const clearallcards = () => {

        setDealerSecondHand([])
        setDealerFirstHand([])
        setPlayerFirstHand([])
        setdealerHandmessage("")
        setPlayerHandmessage("")
    }
    const setAllCards = (res) => {
        console.log(res)
    }




    const setPlayerAllCards = (res) => {
        // setOriginalCards(res)
        if (playerHandIntervalRef.current) {
            clearInterval(playerHandIntervalRef.current);
        }
        setIsDealt(false);
        let i = 0;



        playerHandIntervalRef.current = setInterval(() => {

            if (i < 2) {
                props?.soundsRef?.current?.cardFallSound?.stop();
                props?.soundsRef?.current?.cardFallSound?.play();
                setPlayerFirstHand(prev => [...prev, res[i]]);
                i++;
            }

            else {

                setAllowClick(true)

                setIsDealt(true);
                clearInterval(playerHandIntervalRef.current);
                playerHandIntervalRef.current = null;

            }


        }, 400);
    }


    const setDealerUnsetCards = (res) => {
        console.log(res);
        let i = 0;

        dealerHandIntervalRef.current = setInterval(() => {
            if (i < 5) {

                props?.soundsRef?.current?.cardFallSound?.stop();
                props?.soundsRef?.current?.cardFallSound?.play();


                setDealerFirstHand(prev => [...prev, res[i]]);
                i++;
            } else {

                clearInterval(dealerHandIntervalRef.current);
                setInfoText("Call Or Fold ?");
                setBetBtn("CALL");
                setClearBtn("FOLD");
                setRaiseactivated(true);
            }
        }, 500);
    };

    const setDealerUnsetCardshold = (res) => {
        console.log(res)

        // stop any ongoing dealing first
        if (dealerHandIntervalRef.current) {
            clearInterval(dealerHandIntervalRef.current);
        }

        let i = 0;
        dealerHandIntervalRef.current = setInterval(() => {

            if (i < 2) {
                props?.soundsRef?.current?.cardFallSound?.stop();
                props?.soundsRef?.current?.cardFallSound?.play();
                setDealerSecondHand(prev => [...prev, res[i]]);
                i++;
            }

            else {

                clearInterval(dealerHandIntervalRef.current);
                dealerHandIntervalRef.current = null;
            }


        }, 400);
    }
    const prevstatesetDealerUnsetCards = (res) => {
        console.log(res)
        let i = 0;
        const dealerHandInterval = setInterval(() => {
            if (i < 5) {
                setDealerFirstHand(prev => [...prev, res[i]]);
                i++;
            }

            else {
                if (bonuswinamount > 0) {
                    setWinAmount(bonuswinamount);

                }
                 setInfoText("Call Or Fold ?");
                setBetBtn("CALL");
                setClearBtn("FOLD");
                setRaiseactivated(true);
                clearInterval(dealerHandInterval);


            }
        }, 20);
    }

    const prevstatesetDealerUnsetCardshold = (res) => {
        console.log(res)
        let i = 0;
        const dealerHandInterval = setInterval(() => {
            if (i < 2) {
                setDealerSecondHand(prev => [...prev, res[i]]);
                i++;
            }
        }, 20);

    }

    const revealBoardcards = (res) => {
        let i = 0;
        const dealcardssorted = res;

        dealerHandIntervalRef.current = setInterval(() => {
            if (i < dealcardssorted.length) {
                // Update dealer's first hand (board cards)
                setDealerFirstHand(prev => {
                    const updated = [...prev];
                    updated[i] = dealcardssorted[i];
                    return updated;
                });

                // Play reveal sound only for the last 2 cards
                if (i >= dealcardssorted.length - 2) {
                    const sound = props?.soundsRef?.current?.dealerCardRevealSound;
                    if (sound?.playing()) {
                        sound.stop();
                    }
                    sound?.play();
                }

                i++;
            } else {
                clearInterval(dealerHandIntervalRef.current);
            }
        }, 400);
    };


    const revealDealerCards = (dealerCards) => {
        let j = 0;
        const boardcardssorted = dealerCards;

        setTimeout(() => {
            dealerHandIntervalRef.current = setInterval(() => {
                if (j < boardcardssorted.length) {
                    // Update dealer's second hand (actual dealer cards)
                    setDealerSecondHand(prev => {
                        const updated = [...prev];
                        updated[j] = boardcardssorted[j];
                        return updated;
                    });

                    // Play sound for last 2 cards only
                    if (j >= boardcardssorted.length - 2) {
                        const sound = props?.soundsRef?.current?.dealerCardRevealSound;
                        if (sound?.playing()) {
                            sound.stop();
                        }
                        sound?.play();
                    }

                    j++;
                } else {
                    clearInterval(dealerHandIntervalRef.current);
                }
            }, 400);
        }, 1500); // Delay before revealing dealer's hole cards
    };




    return <div id="cardsContainerholdem" className={isDealt ? "dealtholdem" : ""}>

        <div id="firstHandCardsholdem">

            {
                (props.isPlayer ? playerFirstHand : dealerFirstHand)
                    .map((ele, ind) => {


                        const cardClassName = "paiGowCardholdem"
                        return (

                            // <div key={ind}
                            // className={className}
                            // >
                            <CardCSS
                                key={ind}
                                index={ind}
                                cardTitle={ele}
                                newClassName={cardClassName}

                            />
                            // </div>

                        );
                    })
            }

            {playerHand && (

                <div id="player_handholdem">
                    <h3>{playerHand}</h3>
                </div>
            )}
        </div>


        <div id="secondHandCardsholdem">

            {
                (dealerSecondHand)
                    .map((ele, ind) => {

                        const cardClassName = "paiGowCardholdem"
                        return (


                            <CardCSS

                                key={ind}
                                index={ind}
                                cardTitle={ele}
                                newClassName={cardClassName}

                            />


                        );
                    })
            }
            {dealerhand && <div id="dealer_handholdem">
                <h3>{dealerhand}</h3>
            </div>}
        </div>
    </div>
})

export default CasinoholdemCardsContainer